<div tuiDropdownAlign="right" [tuiDropdown]="moreMenu" [(tuiDropdownOpen)]="open">
  <button
    tuiIconButton
    class="more-button"
    [appearance]="'outline'"
    [iconStart]="'@tui.ellipsis-vertical'"
    [size]="size"
    (click)="onClickButton($event)"
  ></button>
</div>

<ng-template #moreMenu>
  <tui-data-list>
    <ng-container *ngFor="let item of items">
      <button *ngIf="getVisibleItem(item)" tuiOption class="more-menu-item" (click)="onClickItem(item)">
        <app-icon *ngIf="item.icon" color="var(--tui-text-action)" [src]="item.icon" [size]="'20px'"></app-icon>
        {{ item.title }}
      </button>
    </ng-container>
  </tui-data-list>
</ng-template>
